import axios from "axios";
import { apiURL } from "./constants";

// Helper function for gofar API requests (different base path)
const gofarApiRequest = async (endpoint, options = {}) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
  try {
    const response = await axios({
      url: `${apiURL}${endpoint}`,
      method: options.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      data: options.data,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    console.error('There was an error!', error);
    throw error;
  }
};

/**
 * List shipment types with optional filters
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Paginated response with shipment types
 */
export const getShipmentTypes = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.pagination !== undefined) queryParams.append('pagination', params.pagination);
  if (params.search) queryParams.append('search', params.search);

  const queryString = queryParams.toString();
  return gofarApiRequest(`/gofar/shipment-type/${queryString ? `?${queryString}` : ''}`);
};

/**
 * Get a single shipment type by ID
 * @param {number} id - Shipment type ID
 * @returns {Promise<Object>} Shipment type object
 */
export const getShipmentType = async (id) => {
  return gofarApiRequest(`/gofar/shipment-type/${id}/`);
};

/**
 * Create a new shipment type
 * @param {Object} data - Shipment type data
 * @param {string} [data.name]
 * @param {string} [data.description]
 * @param {'kg'|'cbm'} [data.billing_metric='kg'] - Which shipment value invoices show (kg vs cbm)
 * @param {string} [data.invoice_unit_label_en='Kg'] - English unit on invoice PDF (max 20)
 * @param {string} [data.invoice_unit_label_ar='كجم'] - Arabic unit on invoice PDF (max 20)
 * @param {string|null} [data.SHIPMENT_SHIPPING_SOON_CONTENT_SID] - Optional; null/"" → Settings fallback
 * @param {string|null} [data.SHIPMENT_SHIPPED_CONTENT_SID]
 * @param {string|null} [data.SHIPMENT_ARRIVED_CONTENT_SID]
 * @param {string|null} [data.SHIPMENT_OUT_FOR_DELIVERY_CONTENT_SID]
 * @param {string|null} [data.SHIPMENT_DELIVERED_CONTENT_SID]
 * @param {string|null} [data.STORE_CONTENT_SID] - Optional; null/"" → Settings STORE_CONTENT_SID fallback
 * @returns {Promise<Object>} Created shipment type
 */
export const createShipmentType = async (data) => {
  return gofarApiRequest('/gofar/shipment-type/', {
    method: 'POST',
    data,
  });
};

/**
 * Update an existing shipment type
 * @param {number} id - Shipment type ID
 * @param {Object} data - Updated shipment type data
 * @returns {Promise<Object>} Updated shipment type
 */
export const updateShipmentType = async (id, data) => {
  return gofarApiRequest(`/gofar/shipment-type/${id}/`, {
    method: 'PUT',
    data,
  });
};

/**
 * Delete a shipment type
 * @param {number} id - Shipment type ID
 * @returns {Promise<void>}
 */
export const deleteShipmentType = async (id) => {
  return gofarApiRequest(`/gofar/shipment-type/${id}/`, {
    method: 'DELETE',
  });
};

